import { Component, OnInit } from '@angular/core';
import {RealmService} from '../Services/Realm/realm.service';
import {ApiService} from '../Services/Api/api.service';
import {MessageService} from 'primeng/api';
import {FirebaseService} from '../Services/Firebase/firebase.service';

@Component({
  selector: 'app-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.css', '../../assets/layout/style/layout.css']
})
export class CouponsComponent implements OnInit {
  coupons: any;
  constructor(private realm: RealmService, private api: ApiService, private messageService: MessageService, private Rc: FirebaseService) { }

  ngOnInit(): void {
    /*
    this.realm.loginAsync().then(data => {
      this.realm.getCouponRenovationSettings();
    });*/
    this.realm.getCouponRenovationSettings();
    this.api.responseCouponRenovation$.subscribe( data => {
      const dat = JSON.parse(JSON.stringify(data));
      console.log("data coupons: ", dat);
      if (dat.code === 711) {
        const s: any = dat.resultInsuredCoupons;
        console.log('data ws Session: ', s);
        //this.coupons = s;
        let couponsFilter : any[] = [];
        s.map((coupon:any) => {
          console.log(coupon);
          if (coupon.status.indexOf("Cúpon") !== -1) {
            coupon.status = coupon.status.replace('Cúpon', 'Cupón');
          }
          couponsFilter.push(coupon);
          console.log(couponsFilter);
        });
        this.coupons = couponsFilter;
      } else if (dat.code === 0) {
        this.messageService.clear();
        this.messageService.add({severity: 'info', summary: 'Información', detail: 'El usuario no tiene cupones asignados.', sticky: false});
      } else {
        // tslint:disable-next-line:max-line-length
        this.messageService.clear();
        this.messageService.add({severity: 'error', summary: 'error', detail: this.Rc.getStringRC('global_message_' + dat.code), sticky: false});
      }
    });
  }
  newWindow(url: string) {
    window.open(url, '_blank');
  }
}
